export default __webpack_public_path__ + "static/media/login_logo.632c14c2.png";